import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {FieldSelect} from './FieldSelect';
import {Style} from './Style';

export class Field extends BasicEntity {
code: string;
order: number | null;
owner: string;
placeholder: string;
selectFunction: string;
selectedItems: FieldSelect[];
styles: Style[];
subTotalFunction: string;
tabCode: string;
widgetCode: string;
}

